import { useEffect } from "react";
import { useAccount, useConnect, useConnectors } from "wagmi";

const useAutoConnect = () => {
  const connectors = useConnectors();
  const { connect } = useConnect();
  const { isConnected } = useAccount();

  useEffect(() => {
    const isLedgerLive = window?.ethereum?.isLedgerLive || false;

    if (isConnected || !isLedgerLive) {
      return;
    }

    // Use existing injected connector from config, not inline creation
    const injectedConnector = connectors.find((c) => c.id === "injected");
    if (injectedConnector) {
      connect({ connector: injectedConnector });
    }
  }, [connect, connectors, isConnected]);
};

export default useAutoConnect;
